import React from "react";
import { Icon } from "@telia/teddy";
import classnames from "classnames";
import "./Form.less";

/** Migrated from Styleguide */

export interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
    id?: string;
    action?: string;
    method?: string;
    onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
    children?: React.ReactNode;
    className?: string;
}

export interface FormRowProps {
    children?: React.ReactNode;
    className?: string;
}

export interface FormColumnProps {
    size?: string;
    children?: React.ReactNode;
    className?: string;
}

export interface FormSuccessMessageProps {
    children?: React.ReactNode;
    className?: string;
}

export const FormRow: React.FC<FormRowProps> = ({ children, className }) => (
    <div className={classnames("sg-form__row", className)}>{children}</div>
);

export const FormColumn: React.FC<FormColumnProps> = ({ size, children, className }) => (
    <div
        className={classnames("sg-form__column", {
            [`sg-form__column--${size}`]: size,
            [`${className}`]: className,
        })}
    >
        {children}
    </div>
);

export const FormSuccessMessage: React.FC<FormSuccessMessageProps> = ({ children, className }) => (
    <div className={classnames("sg-form__success", className)}>
        <Icon name="checkmark-bold" size="md" className="sg-form__success-icon" />
        {children}
    </div>
);

export interface FormComponent extends React.FC<FormProps> {
    FormRow: typeof FormRow;
    FormColumn: typeof FormColumn;
    FormSuccessMessage: typeof FormSuccessMessage;
}

const Form: FormComponent = ({ id, action, method, onSubmit, children, className, ...restProps }) => (
    <form
        id={id}
        className={classnames("sg-form", className)}
        action={action}
        method={method}
        onSubmit={onSubmit}
        {...restProps}
    >
        <fieldset className="sg-form__fieldset">{children}</fieldset>
    </form>
);

Form.FormRow = FormRow;
Form.FormColumn = FormColumn;
Form.FormSuccessMessage = FormSuccessMessage;

export default Form;
